import { useQuery } from '@tanstack/react-query';

import { parkingApi } from '@api/parking.api';
import { LanguageKey } from '@models/Language';

export const useParkingProduct = (
  parkingProductId: string | null | undefined,
  language: LanguageKey
) => {
  return useQuery(
    ['parkingProduct', parkingProductId],
    () =>
      parkingApi
        .getParkingProduct(parkingProductId!, language)
        .then((res) => res.data),
    { enabled: !!parkingProductId }
  );
};
